export const RENDER_PROFILES = {
  fluid: {
    label: 'Fluidite',
    description: 'FPS prioritaire sur machine standard',
    quality: 'auto',  // Resolved by GPU detection (iGPU → 'low', discrete → 'medium'+)
    interactionFps: 45,
    idleFps: 0,
    hoverRaycastHz: 12,
    shaderVariant: 'fast',
    enableInteractionPostFX: false,
    defaultRealTimeShadows: false,
    maxShadowMapSize: 512,
  },
  balanced: {
    label: 'Equilibre',
    description: 'Compromis qualite/performance',
    quality: 'high',
    interactionFps: 40,
    idleFps: 8,
    hoverRaycastHz: 14,
    shaderVariant: 'full',
    enableInteractionPostFX: false,
    defaultRealTimeShadows: false,
    maxShadowMapSize: 1024,
  },
  quality: {
    label: 'Qualite',
    description: 'Rendu maximal sur machine puissante',
    quality: 'ultra',
    interactionFps: 30,
    idleFps: 15,
    hoverRaycastHz: 16,
    shaderVariant: 'full',
    enableInteractionPostFX: true,
    defaultRealTimeShadows: true,
    maxShadowMapSize: 2048,
  },
};

export const DEFAULT_RENDER_PROFILE = 'fluid';

const LEGACY_QUALITY_TO_PROFILE = {
  low: 'fluid',
  medium: 'fluid',
  high: 'balanced',
  ultra: 'quality',
};

export const profileToQuality = (profile) => {
  const resolved = RENDER_PROFILES[profile] ? profile : DEFAULT_RENDER_PROFILE;
  const q = RENDER_PROFILES[resolved].quality;
  return q === 'auto' ? null : q;  // null = defer to GPU detection
};

export const qualityToProfile = (quality) => LEGACY_QUALITY_TO_PROFILE[quality] || DEFAULT_RENDER_PROFILE;

export const resolveRenderProfile = (profile, legacyQuality = null) => {
  if (profile && RENDER_PROFILES[profile]) {
    return profile;
  }
  if (legacyQuality) {
    return qualityToProfile(legacyQuality);
  }
  return DEFAULT_RENDER_PROFILE;
};

export const getRenderProfileConfig = (profile) => {
  const resolved = resolveRenderProfile(profile);
  return RENDER_PROFILES[resolved];
};

export const clampShadowMapSizeForProfile = (profile, requestedSize, enableRealTimeShadows = false) => {
  if (!enableRealTimeShadows) {
    return 0;
  }

  const resolvedProfile = resolveRenderProfile(profile);
  const maxProfileSize = getRenderProfileConfig(resolvedProfile).maxShadowMapSize;
  const size = Number.isFinite(requestedSize) ? requestedSize : maxProfileSize;

  return Math.min(size, maxProfileSize);
};
